var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNhlstenden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122.728,
    height: 96,
    viewBox: "0 0 122.728 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.728,
    height: 96,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.885,34.841V18.56H32.314v10.8L22.581,18.29H21.65V34.58h2.571V23.757l9.752,11.083Z",
    transform: "translate(-1.486 -1.255)",
    fill: "#00294b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.837,34.6h2.58V18.58h-2.58v6.38H42.809V18.58h-2.6V34.6h2.6V27.27h8.056Z",
    transform: "translate(-2.759 -1.275)",
    fill: "#00294b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.479,58a3.09,3.09,0,0,1-2,.605,5.086,5.086,0,0,1-4.2-2.468L20.46,57.516a6.769,6.769,0,0,0,2.5,2.552A6.9,6.9,0,0,0,26.5,61a5.8,5.8,0,0,0,3.847-1.276,4.155,4.155,0,0,0,1.518-3.362,3.728,3.728,0,0,0-.931-2.617,8.875,8.875,0,0,0-2.887-1.937l-1.8-.829a8.5,8.5,0,0,1-1.723-1.015A1.575,1.575,0,0,1,24,48.686a1.648,1.648,0,0,1,.689-1.481,2.878,2.878,0,0,1,1.723-.494,3.894,3.894,0,0,1,3.39,1.975L31.6,47.3a5.725,5.725,0,0,0-2.114-2.077,6.012,6.012,0,0,0-3.055-.792,5.457,5.457,0,0,0-3.6,1.164,3.876,3.876,0,0,0-1.453,3.139,3.632,3.632,0,0,0,.987,2.6,8.476,8.476,0,0,0,2.794,1.863l1.77.829a7.708,7.708,0,0,1,1.807,1.071,1.707,1.707,0,0,1,.55,1.332,2,2,0,0,1-.8,1.574",
    transform: "translate(-1.404 -3.048)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.464,60.69V46.98h5.411V44.67H34.51v2.31h5.383V60.69Z",
    transform: "translate(-2.368 -3.065)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.263,58.38H54.011V53.36h6V51.125h-6v-4.1h7.963V44.67H51.44V60.69H62.263Z",
    transform: "translate(-3.53 -3.065)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.81,44.669H84.79v16.02h5.02a8.86,8.86,0,0,0,6.352-2.245,8.173,8.173,0,0,0,0-11.558,8.941,8.941,0,0,0-6.352-2.217m4.415,12.108a6.094,6.094,0,0,1-4.443,1.6H87.361V47h2.431a6.252,6.252,0,0,1,4.452,1.537,5.382,5.382,0,0,1,1.639,4.117,5.533,5.533,0,0,1-1.658,4.126",
    transform: "translate(-5.818 -3.064)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.39,53.36h5.979V51.125h-5.989v-4.1h7.954V44.67H102.81V60.69h10.823V58.38h-8.252Z",
    transform: "translate(-7.055 -3.065)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.264,44.651v10.8L118.531,44.39H117.6V60.671h2.571V49.848l9.761,11.083h.866V44.651Z",
    transform: "translate(-8.07 -3.046)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.13,74.9h74.9V41.6H72.293V52.334l-9.668-10.99h-.931v16.28h2.58V46.8l8.019,9.081V72.163H2.868V2.738H72.293V31.006h-15v-13.7H54.718v16.02H75.031V0H.13Z",
    transform: "translate(-0.009 0)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,92.261A2.569,2.569,0,0,0,1.49,93.1V88.75H0V99.377H1.49V95.242a1.591,1.591,0,0,1,.447-1.164,1.554,1.554,0,0,1,1.136-.438,1.454,1.454,0,0,1,1.108.447,1.686,1.686,0,0,1,.41,1.174V99.4h1.49V95.027a2.794,2.794,0,0,0-.7-1.993A2.41,2.41,0,0,0,3.5,92.261",
    transform: "translate(0 -6.09)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.557,93.554A3.669,3.669,0,0,0,11.94,92.52a3.614,3.614,0,0,0-2.608,1.043,3.67,3.67,0,0,0,0,5.16,3.726,3.726,0,0,0,5.225,0,3.632,3.632,0,0,0,.033-5.137l-.033-.033M13.5,97.792l-.009-.019a2.076,2.076,0,0,1-1.546.643,2.049,2.049,0,0,1-1.546-.643,2.45,2.45,0,0,1,0-3.232,2.113,2.113,0,0,1,1.565-.643,2.056,2.056,0,0,1,1.537.661,2.421,2.421,0,0,1,0,3.232",
    transform: "translate(-0.568 -6.349)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.422,93.666a2.859,2.859,0,0,0-2.459-1.136,3.258,3.258,0,0,0-2.422.931,3.416,3.416,0,0,0-.931,2.505,3.453,3.453,0,0,0,.931,2.505,3.258,3.258,0,0,0,2.422.978,2.933,2.933,0,0,0,2.347-.894v.484a1.863,1.863,0,0,1-.568,1.481,2.2,2.2,0,0,1-1.518.5,3.883,3.883,0,0,1-2.44-.987l-.81,1a4.713,4.713,0,0,0,3.344,1.313,3.547,3.547,0,0,0,2.533-.931,3.3,3.3,0,0,0,.931-2.533V92.688h-1.36Zm-.708,3.958a2.1,2.1,0,0,1-1.481.568,2.049,2.049,0,0,1-1.518-.568,2.136,2.136,0,0,1-.605-1.583A2.058,2.058,0,0,1,21.081,93.9c.05,0,.1,0,.152,0a2.152,2.152,0,0,1,1.481.54,2.021,2.021,0,0,1,.615,1.6,2.114,2.114,0,0,1-.615,1.583",
    transform: "translate(-1.208 -6.349)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.735,92.52a3.457,3.457,0,0,0-2.552,1.052,3.569,3.569,0,0,0-1.043,2.589,3.467,3.467,0,0,0,1.062,2.58,3.723,3.723,0,0,0,2.673,1.043,3.912,3.912,0,0,0,2.794-1.118l-.689-1.043a2.993,2.993,0,0,1-2.021.82,2.359,2.359,0,0,1-1.518-.484,2.132,2.132,0,0,1-.754-1.341h5.188a4.237,4.237,0,0,0,.112-.931,3.1,3.1,0,0,0-.931-2.282,3.178,3.178,0,0,0-2.319-.885m-2.021,2.962a2.162,2.162,0,0,1,.717-1.239,1.923,1.923,0,0,1,1.3-.456,1.791,1.791,0,0,1,1.257.456,1.64,1.64,0,0,1,.522,1.239Z",
    transform: "translate(-1.862 -6.349)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.093,95.564l-.671-.27a2.9,2.9,0,0,1-.717-.373.57.57,0,0,1-.2-.447q0-.671.931-.671a2.169,2.169,0,0,1,1.63.708l.81-.931A3,3,0,0,0,38.46,92.5a2.8,2.8,0,0,0-1.76.54,1.752,1.752,0,0,0-.689,1.472,1.629,1.629,0,0,0,.466,1.248,4.337,4.337,0,0,0,1.369.838l.708.3a4.076,4.076,0,0,1,.745.382.55.55,0,0,1,.233.484.652.652,0,0,1-.317.577,1.5,1.5,0,0,1-.8.2,2.728,2.728,0,0,1-1.956-.987l-.848.931A3.346,3.346,0,0,0,38.4,99.82a2.969,2.969,0,0,0,1.863-.559,1.863,1.863,0,0,0,.726-1.639,1.654,1.654,0,0,0-.456-1.211,4.427,4.427,0,0,0-1.444-.848",
    transform: "translate(-2.444 -6.347)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.467,98.426a2.068,2.068,0,0,1-1.565-.643,2.421,2.421,0,0,1,0-3.223,2.048,2.048,0,0,1,1.555-.661,2.236,2.236,0,0,1,1.863,1.062l1.043-.82a3.277,3.277,0,0,0-1.2-1.174,3.406,3.406,0,0,0-1.723-.428,3.614,3.614,0,0,0-2.608,1.043,3.654,3.654,0,0,0,0,5.169A3.55,3.55,0,0,0,46.439,99.8a3.259,3.259,0,0,0,2.934-1.611l-1.043-.81a2.265,2.265,0,0,1-1.863,1.043",
    transform: "translate(-2.934 -6.35)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.122,92.261a2.569,2.569,0,0,0-2.012.838V88.75H51.62V99.377h1.49V95.242a1.591,1.591,0,0,1,.447-1.164,1.554,1.554,0,0,1,1.136-.438,1.431,1.431,0,0,1,1.108.447,1.686,1.686,0,0,1,.41,1.174V99.4H57.7V95.027a2.794,2.794,0,0,0-.7-1.993,2.4,2.4,0,0,0-1.881-.773",
    transform: "translate(-3.542 -6.09)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.147,93.554a3.805,3.805,0,0,0-5.225.009,3.67,3.67,0,0,0,0,5.16,3.726,3.726,0,0,0,5.225,0,3.632,3.632,0,0,0,.033-5.137l-.033-.033M65.1,97.773a2.076,2.076,0,0,1-1.546.643,2.049,2.049,0,0,1-1.546-.643,2.45,2.45,0,0,1,0-3.232,2.113,2.113,0,0,1,1.565-.643,2.056,2.056,0,0,1,1.537.661,2.253,2.253,0,0,1,.615,1.621,2.218,2.218,0,0,1-.624,1.593",
    transform: "translate(-4.108 -6.349)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.447,93.554A3.725,3.725,0,0,0,72.83,92.52a3.61,3.61,0,0,0-2.608,1.043,3.67,3.67,0,0,0,0,5.16,3.726,3.726,0,0,0,5.225,0,3.632,3.632,0,0,0,.033-5.137l-.033-.033m-1.08,4.219a2.076,2.076,0,0,1-1.546.643,2.049,2.049,0,0,1-1.546-.643,2.45,2.45,0,0,1,0-3.232,2.113,2.113,0,0,1,1.565-.643,2.056,2.056,0,0,1,1.537.661,2.253,2.253,0,0,1,.615,1.621,2.218,2.218,0,0,1-.624,1.593",
    transform: "translate(-4.746 -6.349)",
    fill: "#00294b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.49,
    height: 10.627,
    transform: "translate(73.476 82.66)",
    fill: "#00294b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNhlstenden);
export default __webpack_public_path__ + "static/media/logo-nhlstenden.91767aedd958b2c191a633b9ef876cd5.svg";
export { ForwardRef as ReactComponent };